import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {isNullOrUndefined} from 'util';

@Component({
    selector: 'lib-rc-contrast-colors',
    template: `<button class="colors-contrast-button" [ngClass]="{'active': active}"
        attr.aria-label="{{label}}" (click)="toggle()">
  <ng-content></ng-content>
</button>`,
    styles: [`.colors-contrast-button{background-color:#00f}.colors-contrast-button.active{background-color:red}`]
})

export class RcContrastColorsComponent implements OnInit {

    @Input() label: string;
    @Input() active: boolean = false;
    @Output() clickCallback: EventEmitter<any> = new EventEmitter();

    private colorsContrastClass: string = 'rc-contrast-colors';

    ngOnInit() {
        if (this.hasClass()) {
            this.active = true;
        }
    }

    /**
     * add / remove the contrast colors class from body
     */
    public toggle(): void {
        if (!this.active) {
            document.body.classList.add(this.colorsContrastClass);
        } else {
            document.body.className = document.body.className.replace(this.colorsContrastClass, '');
        }

        this.active = !this.active;
        if (this.clickCallback.observers.length) {
            this.clickCallback.emit(this.active);
        }
    }

    /**
     * check if body has the colors contrast class
     * @returns boolean
     */
    public hasClass(): boolean {
        const res =  document.body.className.match(new RegExp('(\\s|^)'+this.colorsContrastClass+'(\\s|$)'));
        return !isNullOrUndefined(res);
    }
}
